import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    addContact: 'Add a contact',
    ccUser: 'Include me in this email via CC',
    chooseContacts: 'Choose',
    sendTo: 'Send to',
  },
  fr: {
    addContact: 'Ajouter un contact',
    ccUser: 'M’ajouter en copie de cet e-mail',
    chooseContacts: 'Choisir',
    sendTo: 'Envoyer à',
  },
} as const);
